import { cx } from './classes.js'

/** Merges props supplied by a `render` element with props owned by the component. */
export function mergeRenderProps(
  base: Record<string, unknown>,
  own: Record<string, unknown>,
): Record<string, unknown> {
  return {
    ...base,
    ...own,
    className: cx(base.className as string | undefined, own.className as string | undefined),
  }
}
